module.exports = __webpack_public_path__ + "img/messages-question.73c7fee8.svg";